module.exports = __webpack_public_path__ + "img/papillon.87beab75.png";